import {createFileRoute, Outlet} from '@tanstack/react-router';

import {ImagesCacheProvider} from 'src/contexts/ImagesCacheProvider';

export const Route = createFileRoute('/model/add-samples')({
  component: ModelAddSamplesLayout,
});

function ModelAddSamplesLayout() {
  return (
    <ImagesCacheProvider mode='model-archive'>
      <Outlet />
    </ImagesCacheProvider>
  );
}
